import React, { useEffect, useState } from 'react';
import Layouts from '../../../components/Layouts';
import {
  Button,
  Form,
  Modal,
  Select,
  Space,
  Table,
  Tabs,
  Typography,
  Upload,
} from 'antd';
import { getDirectusClient } from '../../../lib/directus';
import { EyeOutlined, DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import Caja from '../components/Caja';
import Grupo from '../components/Grupo';
import Serial from '../components/Serial';
import AddNoSerial from '../components/AddNoSerial';
import Column from 'antd/es/table/Column';
import {
  createItem,
  readItems,
  readUsers,
  updateItem,
  updateItems,
  updateUser,
} from '@directus/sdk';
import { useSelector } from 'react-redux'; // Add this import
import { formatPrice, truncateSerial } from '../../../lib/utils';
import Constants from '../../../lib/Constants';
const { Title } = Typography;
const { Option } = Select;
const arraytotalproductos = [];
let deletecambio = false;
function LoanCreate(props) {
  const signoMoneda = useSelector(state => state.signoMoneda.signo_moneda);
  const omitir1 = useSelector(state => state.omitir1.omitir1);
  const [vendedoresloan, setVendedoresloan] = useState([]);
  const [vendedorselect, setVendedorselect] = useState({});

  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [serialeslist, setSerialeslist] = useState([]);
  const [modalseriales, setModalseriales] = useState(false);
  const [productosagregados, setProductosagregados] = useState([]);
  const [productosagregadosver, setProductosagregadosver] = useState([]);
  const [fileList, setFileList] = useState([]);

  const [total, setTotal] = useState(0); // Define total as a state variable
  const userRoleID = useSelector(state => state.userdata.role?.name);
  const user = useSelector(state => state.userdata?.id);
  const userBodega = useSelector(state => state.userdata.bodega?.id);
  const [form] = Form.useForm();
  const [vendorSearch, setVendorSearch] = useState('');

  // Add userBodega selector
  const handleAddNoSerialItem = item => {
    setProductosagregados(prev => [
      ...prev,
      { ...item, isNonSerialized: true },
    ]);
  };
  const items = [
    {
      key: '1',
      label: `Por Caja`,
      children: (
        <Caja
          productosagregados={productosagregados}
          setProductosagregados={setProductosagregados}
        />
      ),
    },
    {
      key: '2',
      label: `Por Serial`,
      children: (
        <Serial
          productosagregados={productosagregados}
          setProductosagregados={setProductosagregados}
        />
      ),
    },
    {
      key: '3',
      label: `Por Caja y Grupo`,
      children: (
        <Grupo
          productosagregados={productosagregados}
          setProductosagregados={setProductosagregados}
        />
      ),
    },
    {
      key: '4',
      label: `No Serializado`,
      children: (
        <AddNoSerial
          onAddItem={handleAddNoSerialItem}
          productosagregados={productosagregados || []}
        />
      ),
    },
  ];

  const getVendedoresloan = async () => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readUsers({
          fields: ['id', 'first_name', 'prestamo_usado', 'tope_de_prestamo'],
          filter: {
            role: {
              name: { _contains: 'vendedor' },
            },
            ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
              ? {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                }
              : {}),
          },
          sort: ['first_name'],
        })
      );
      setVendedoresloan(response);
    } catch (err) {
      console.error('Error fetching vendors:', err);
      Modal.error({
        title: 'Error',
        content: 'Error al cargar los vendedores',
      });
    }
  };

  const handleSearch = async value => {
    try {
      setVendorSearch(value);
      if (!value) {
        await getVendedoresloan();
        return;
      }
      const directus = await getDirectusClient();
      const response = await directus.request(
        readUsers({
          search: value,
          fields: ['id', 'first_name', 'prestamo_usado', 'tope_de_prestamo'],
          filter: {
            role: {
              name: { _contains: 'vendedor' },
            },
            ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
              ? {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                }
              : {}),
          },
        })
      );
      setVendedoresloan(response);
    } catch (error) {
      console.error('Error searching vendors:', error);
    }
  };

  useEffect(() => {
    getVendedoresloan();
  }, []);

  const onFinish = async ev => {
    const hasSerializedItems = arraytotalproductos.length > 0;
    const hasNonSerializedItems =
      productosagregadosver.filter(item => item.isNonSerialized).length > 0;

    if (!hasSerializedItems && !hasNonSerializedItems) {
      Modal.warning({
        title: 'No hay productos para prestar',
        content: 'Por favor agregue productos al préstamo e intente de nuevo',
      });
      setLoadings(false);
      return;
    }

    if (!vendedorselect || !vendedorselect.id) {
      Modal.error({
        title: 'Error',
        content: 'No se ha seleccionado un vendedor válido',
      });
      return;
    }

    Modal.confirm({
      title: '¿Está seguro de realizar el préstamo?',
      content: (
        <div>
          <p>
            Se va a realizar un préstamo para el vendedor:{' '}
            <b>
              {vendedorselect.first_name ||
                vendedorselect.nombre ||
                vendedorselect.id}
            </b>
          </p>
          {hasSerializedItems && (
            <p>
              Seriales a prestar: <b>{arraytotalproductos.length}</b>
            </p>
          )}
          {hasNonSerializedItems && (
            <p>
              Productos no serializados a prestar:{' '}
              <b>
                {productosagregadosver
                  .filter(item => item.isNonSerialized)
                  .reduce((acc, item) => acc + (item.quantity || 0), 0)}
              </b>
            </p>
          )}
          <p>¿Desea continuar?</p>
        </div>
      ),
      okText: 'Sí, continuar',
      cancelText: 'Cancelar',
      onOk: async () => {
        setLoadings(true);
        const directus = await getDirectusClient();

        // Mostrar modal de progreso si hay muchos seriales
        let progressModal = null;
        if (hasSerializedItems && arraytotalproductos.length > 100) {
          progressModal = Modal.info({
            title: 'Procesando préstamo',
            content: `Iniciando procesamiento de ${arraytotalproductos.length} seriales...`,
            okButtonProps: { style: { display: 'none' } },
            closable: false,
          });
        }

        try {
          let arrguardar = [];
          let arrguardarp = [];
          let arrproducto = [];

          // Procesar productos serializados si existen
          if (hasSerializedItems) {
            arraytotalproductos.map(p => {
              arrguardar.push({ id: p.id, user: '+', estado: 8 });
              arrguardarp.push({ id: p.id, prestamo: '+', estado: 8 });
            });
          }

          // Procesar productos no serializados si existen
          if (hasNonSerializedItems) {
            productosagregadosver.map(pro => {
              if (pro.isNonSerialized) {
                arrproducto.push({ id: pro.id });
              }
            });
          }

          // Crear el préstamo
          const loanData = {
            vendedor: ev.vendedor,
            tipo: 'prestamo',
            estado: 'solicitud_prestamo',
          };

          // NO agregar seriales aquí, los agregaremos después en lotes
          const loanResponse = await directus.request(
            createItem('prestamos', loanData)
          );

          if (loanResponse.id) {
            // NO procesar seriales en la BD, solo crear el préstamo base

            // Cerrar modal de progreso si existe
            if (progressModal) {
              progressModal.destroy();
            }

            // Crear objeto con arrays de serializados y no serializados
            const prestamoObject = {
              id: loanResponse.id,
              user_created: user,
              vendedor: ev.vendedor,
              vendedor_nombre: vendedorselect.first_name,
              fecha_creacion: new Date().toISOString(),
              estado: 'solicitud_prestamo',
              total_prestado: total,
              serializados: {
                cantidad: arraytotalproductos.length,
                items: arraytotalproductos.map(item => ({
                  id: item.id,
                })),
              },
           
            };

            // Función para enviar el objeto a la API externa
            const enviarPrestamoAAPI = async prestamoData => {
              try {
                const response = await fetch(
                  Constants.URL_COMPLEMENTO + '/api/prestamos/crear',
                  {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(prestamoData),
                  }
                );

                if (response.ok) {
                  const result = await response.json();

                  return { success: true, data: result };
                } else {
                  const errorData = await response.text();
                  console.error(
                    'Error en la respuesta de la API:',
                    response.status,
                    errorData
                  );
                  return {
                    success: false,
                    error: `HTTP ${response.status}: ${errorData}`,
                  };
                }
              } catch (error) {
                console.error('Error enviando préstamo a API externa:', error);
                return { success: false, error: error.message };
              }
            };

            // Enviar el objeto a la API externa
            const apiResult = await enviarPrestamoAAPI(prestamoObject);

            if (apiResult.success) {
              // Usar el historialId de la respuesta para crear detalle_historial_ns
              if (apiResult.data.historialId && hasNonSerializedItems) {
                for (const item of productosagregadosver.filter(
                  item => item.isNonSerialized
                )) {
                  const inventarioNoSerial = await directus.request(
                    readItems('inventario_no_serial', {
                      fields: ['*'],
                      filter: { producto: { id: { _eq: item.id } } },
                    })
                  );

                  if (inventarioNoSerial && inventarioNoSerial.length > 0) {
                    const inventarioNsId = inventarioNoSerial[0].id;

                    const existingPrestamo = await directus.request(
                      readItems('inventario_ns_prestamo', {
                        fields: ['*'],
                        filter: {
                          inventario_ns: { _eq: inventarioNsId },
                          estado: { _eq: 'solicitud_prestamo' },
                          prestamos: {
                            prestamos_id: {
                              vendedor: { _eq: ev.vendedor },
                            },
                          },
                        },
                        limit: 1,
                      })
                    );

                    let inventarioNsPrestamoResponse;

                    if (existingPrestamo && existingPrestamo.length > 0) {
                      const existingItem = existingPrestamo[0];
                      inventarioNsPrestamoResponse = await directus.request(
                        updateItem('inventario_ns_prestamo', existingItem.id, {
                          cantidad:
                            Number(existingItem.cantidad) +
                            Number(item.quantity),
                          prestamos: {
                            create: [
                              {
                                inventario_ns_prestamo_id:
                                  existingItem.id.toString(),
                                prestamos_id: { id: loanResponse.id },
                              },
                            ],
                            update: [],
                            delete: [],
                          },
                        })
                      );
                    } else {
                      inventarioNsPrestamoResponse = await directus.request(
                        createItem('inventario_ns_prestamo', {
                          cantidad: item.quantity,
                          estado: 'solicitud_prestamo',
                          inventario_ns: inventarioNsId,
                          prestamos: {
                            create: [
                              {
                                inventario_ns_prestamo_id: '+',
                                prestamos_id: { id: loanResponse.id },
                              },
                            ],
                          },
                        })
                      );
                    }

                    // Usar el historialId de la API externa
                    await directus.request(
                      createItem('detalle_historial_ns', {
                        cantidad: item.quantity,
                        historial_seriales: {
                          create: [
                            {
                              detalle_historial_ns_id: '+',
                              historial_seriales_id: {
                                id: apiResult.data.historialId,
                              },
                            },
                          ],
                        },
                        prestamo_ns_p: inventarioNsPrestamoResponse.id,
                      })
                    );
                  }
                }
              }
            } else {
              console.error(
                'Error enviando préstamo a API externa:',
                apiResult.error
              );
              // No fallar el proceso principal si la API externa falla
              Modal.warning({
                title: 'Advertencia',
                content: `El préstamo se creó exitosamente, pero hubo un problema enviando los datos a la API externa: ${apiResult.error}`,
              });
            }

            // Los productos no serializados se procesarán después de recibir la respuesta de la API externa

            Modal.success({
              title: 'Proceso exitoso',
              content: `Se realizó el préstamo correctamente${
                hasSerializedItems
                  ? ` con ${arraytotalproductos.length} seriales procesados`
                  : ''
              }${
                hasNonSerializedItems
                  ? ` y ${productosagregadosver
                      .filter(item => item.isNonSerialized)
                      .reduce(
                        (acc, item) => acc + (item.quantity || 0),
                        0
                      )} productos no serializados agregados`
                  : ''
              }`,
            });

            setModalseriales(false);
            setProductosagregados([]);
            setProductosagregadosver([]);
            arraytotalproductos.splice(0, arraytotalproductos.length);
            setVendedorselect({});
          }
          setLoadings(false);
        } catch (error) {
          // Cerrar modal de progreso si existe
          if (progressModal) {
            progressModal.destroy();
          }

          console.error('Error creating loan:', error);
          Modal.error({
            title: 'Error',
            content: 'Error al crear el préstamo',
          });
          setLoadings(false);
        }
      },
      onCancel: () => {
        // No hacer nada, el usuario canceló
      },
    });
  };

  const selecionado = ev => {
    setVendedorselect(vendedoresloan.find(item => item.id === ev));
    setVendorSearch('');
    getVendedoresloan();
  };

  const onChange = key => {};

  useEffect(() => {
    ejecutaconversion();
  }, [productosagregados]);

  const ejecutaconversion = () => {
    // Separate items into serialized and non-serialized
    const serializedItems = productosagregados.filter(
      item => !item.isNonSerialized
    );
    const nonSerializedItems = productosagregados.filter(
      item => item.isNonSerialized
    );

    // --- Process Serialized Items ---
    // Clear and rebuild arraytotalproductos with current serialized items
    arraytotalproductos.length = 0;
    serializedItems.forEach(item => {
      arraytotalproductos.push({
        id: item.id,
        serial: item.serial,
        producto: item.producto,
        isNonSerialized: false,
      });
    });

    const nonSerializedMap = {};
    nonSerializedItems.forEach(item => {
      const productId = item.producto?.id;
      if (!productId) {
        console.warn(
          'ejecutaconversion: Skipping non-serialized item due to missing product ID:',
          item
        );
        return;
      }
      if (!nonSerializedMap[productId]) {
        nonSerializedMap[productId] = {
          id: productId,
          producto: item.nombre,
          isNonSerialized: true,
          quantity: 0,
          precio: item.producto?.preciosinimp || 0,
          impuesto: item.producto?.grupo?.impuesto || 0,
          seriales: [],
          rawItems: [],
        };
      }
      nonSerializedMap[productId].quantity += Number(item.quantity) || 0;
      nonSerializedMap[productId].rawItems.push(item);
      nonSerializedMap[productId].precio = item.producto?.preciosinimp || 0;
      nonSerializedMap[productId].impuesto =
        item.producto?.grupo?.impuesto || 0;
    });

    // --- Combine Processed Items for Table Display ---
    const finalProductosMap = {};

    // Add serialized items
    arraytotalproductos.forEach(item => {
      const productId = item.producto?.id;
      if (!productId) return;

      if (!finalProductosMap[productId]) {
        finalProductosMap[productId] = {
          id: productId,
          producto: item.producto?.nombre,
          isNonSerialized: false,
          seriales: [],
          quantity: 0,
          precio: item.producto?.preciosinimp || 0,
          impuesto: item.producto?.grupo?.impuesto || 0,
          rawItems: [],
        };
      }
      finalProductosMap[productId].seriales.push({
        serial: item.serial,
        id: item.id,
      });
      finalProductosMap[productId].rawItems.push(item);
      finalProductosMap[productId].quantity =
        finalProductosMap[productId].seriales.length;
    });

    // Add non-serialized items
    Object.values(nonSerializedMap).forEach(item => {
      const productId = item.id;
      if (!finalProductosMap[productId]) {
        finalProductosMap[productId] = {
          ...item,
          seriales: [],
        };
      } else {
        // Merge if product exists as both types (shouldn't happen but handle it)
        console.warn(
          `Product ID ${productId} exists as both serialized and non-serialized. Merging.`
        );
        finalProductosMap[productId].isNonSerialized = true;
        finalProductosMap[productId].quantity += item.quantity;
        finalProductosMap[productId].rawItems.push(...item.rawItems);
      }
    });

    // Convert to array and update state
    const productosArray = Object.values(finalProductosMap);

    setProductosagregadosver(productosArray.length > 0 ? productosArray : []);
  };

  useEffect(() => {
    const calculateTotal = productosagregadosver.reduce((acc, producto) => {
      // Determine quantity based on item type (use the 'quantity' property which is now set for both)
      const cantidad = producto.quantity || 0;

      // Ensure precio and impuesto are treated as numbers
      const precio = parseFloat(producto.precio) || 0;
      const impuesto = parseFloat(producto.impuesto) || 0;

      const preciot = cantidad * precio; // Use numeric quantity and price
      const totalp = parseFloat(preciot + (preciot * impuesto) / 100).toFixed(
        2
      );
      return acc + parseFloat(totalp);
    }, 0);

    setTotal(calculateTotal);
  }, [productosagregadosver]);

  const processFile = async file => {
    try {
      console.log('=== INICIO PROCESAMIENTO DE ARCHIVO (LoanCreate) ===');
      console.log('Archivo recibido:', file.name, 'Tamaño:', file.size);

      const text = await file.text();
      console.log(
        'Contenido del archivo (primeras 5 líneas):',
        text.split('\n').slice(0, 5)
      );

      const serialNumbers = text
        .split('\n')
        .map(line => line.trim())
        .filter(line => line.length > 0);

      console.log('Seriales extraídos del archivo:', serialNumbers.length);
      console.log('Primeros 5 seriales:', serialNumbers.slice(0, 5));

      const truncatedSerialNumbers = serialNumbers.map(serial =>
        truncateSerial(serial, omitir1)
      );

      console.log('Configuración omitir1:', omitir1);
      console.log(
        'Seriales después del truncamiento:',
        truncatedSerialNumbers.length
      );

      // Verificar si el truncamiento cambió algún serial
      const changedSerials = serialNumbers.filter(
        (original, index) => original !== truncatedSerialNumbers[index]
      );
      if (changedSerials.length > 0) {
        console.log('Seriales modificados por truncamiento:', changedSerials);
      }

      setLoading(true);
      const directus = await getDirectusClient();

      const batchSize = 50;
      const batchPromises = [];

      console.log('Configuración de búsqueda:');
      console.log('- Tamaño de lote:', batchSize);
      console.log(
        '- Total de lotes:',
        Math.ceil(truncatedSerialNumbers.length / batchSize)
      );

      for (let i = 0; i < truncatedSerialNumbers.length; i += batchSize) {
        const batch = truncatedSerialNumbers.slice(i, i + batchSize);
        console.log(
          `Lote ${Math.floor(i / batchSize) + 1}:`,
          batch.length,
          'seriales'
        );

        batchPromises.push(
          directus.request(
            readItems('seriales', {
              fields: ['*', 'producto.*', 'producto.grupo.*', 'producto.id'],
              filter: {
                _and: [
                  {
                    serial: { _in: batch },
                  },
                  {
                    estado: { _eq: 1 },
                  },
                ],
              },
              limit: -1,
            })
          )
        );
      }

      console.log('Ejecutando consultas a la base de datos...');
      const batchResults = await Promise.all(batchPromises);
      console.log(
        'Resultados de lotes:',
        batchResults.map(
          (result, index) =>
            `Lote ${index + 1}: ${result.length} seriales encontrados`
        )
      );

      const allSerials = batchResults.flat();
      console.log('Total de seriales encontrados en BD:', allSerials.length);

      if (!allSerials || allSerials.length === 0) {
        console.error('❌ ERROR: No se encontraron seriales válidos');
        console.error('Seriales originales:', serialNumbers.slice(0, 10));
        console.error(
          'Seriales truncados:',
          truncatedSerialNumbers.slice(0, 10)
        );
        console.error('Configuración omitir1:', omitir1);

        Modal.error({
          title: 'Seriales no encontrados',
          content: 'No se encontraron seriales válidos en el archivo',
        });
        return;
      }

      // Validar seriales
      const foundSerials = new Set(allSerials.map(s => s.serial));
      const invalidSerials = truncatedSerialNumbers.filter(
        serial => !foundSerials.has(serial)
      );

      if (invalidSerials.length > 0) {
        const DownloadButton = () => (
          <Button
            onClick={() => {
              const blob = new Blob([invalidSerials.join('\n')], {
                type: 'text/plain',
              });
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'seriales_invalidos.txt';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            }}
          >
            Descargar seriales inválidos
          </Button>
        );
        Modal.info({
          title: 'Seriales inválidos o no disponibles',
          content: (
            <div>
              <div style={{ marginBottom: 8 }}>
                <b>Cantidad de seriales inválidos:</b> {invalidSerials.length}
              </div>
              <div
                style={{
                  maxHeight: 200,
                  overflowY: 'auto',
                  background: '#f5f5f5',
                  border: '1px solid #ddd',
                  padding: 8,
                  fontFamily: 'monospace',
                  fontSize: 13,
                  marginBottom: 8,
                  whiteSpace: 'pre-wrap',
                }}
              >
                {invalidSerials.join('\n')}
              </div>
              <DownloadButton />
            </div>
          ),
        });
      }

      // Procesar seriales válidos
      const nuevosSeriales = allSerials.map(serial => ({
        ...serial,
        prestamo: '+',
      }));

      setProductosagregados(prev => [...prev, ...nuevosSeriales]);

      Modal.success({
        title: 'Seriales cargados',
        content: `Se cargaron ${allSerials.length} seriales correctamente`,
      });
    } catch (error) {
      console.error('❌ ERROR en processFile:', error);
      console.error('Stack trace:', error.stack);
      Modal.error({
        title: 'Error',
        content: 'Error al procesar el archivo de seriales',
      });
    } finally {
      setLoading(false);
    }
  };

  // Updated removal logic for the table's "Quitar producto" button
  const handleRemoveProduct = record => {
    Modal.confirm({
      title: '¿Quieres eliminar este producto?',
      content: `Se eliminarán ${record.seriales.length} seriales asociados`,
      onOk() {
        if (record.isNonSerialized) {
          // Handle non-serialized item removal
          const updatedProductos = productosagregados.filter(
            item => !(item.isNonSerialized && item.producto?.id === record.id)
          );
          setProductosagregados(updatedProductos);
        } else {
          // Handle serialized item removal
          const updatedProductos = productosagregados.filter(
            item => !record.seriales.some(serial => serial.id === item.id)
          );
          setProductosagregados(updatedProductos);
        }

        // Force table update
        setProductosagregadosver(prev =>
          prev.filter(item => item.id !== record.id)
        );
      },
    });
  };

  // Update the table's "Action" column to use the new handleRemoveProduct function
  const columns = [
    {
      title: 'Producto',
      dataIndex: 'producto',
    },
    {
      title: 'Cantidad',
      dataIndex: 'quantity',
      render: text => text || 0,
    },
    {
      title: 'Precio unitario',
      dataIndex: 'precio',
      render: precio =>
        `${formatPrice(precio.toLocaleString(), signoMoneda) || 0}`,
    },
    {
      title: 'Impuesto',
      dataIndex: 'impuesto',
      render: impuesto => `${impuesto || 0}%`,
    },
    {
      title: 'Total parcial',
      key: 'totalparcial',
      render: (_, record) => {
        const cantidad = record.quantity || 0;
        const precio = parseFloat(record.precio) || 0;
        const impuesto = parseFloat(record.impuesto) || 0;
        const subtotal = precio * cantidad;
        const valorImpuesto = subtotal * (impuesto / 100);
        const total = formatPrice(subtotal + valorImpuesto, signoMoneda);
        return total.toLocaleString();
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {!record.isNonSerialized && (
            <Button
              onClick={() => {
                setSerialeslist(record.seriales);
                setModalseriales(true);
              }}
              icon={<EyeOutlined />}
              type="primary"
            >
              Ver seriales
            </Button>
          )}
          <Button
            onClick={() => handleRemoveProduct(record)}
            icon={<DeleteOutlined />}
            type="primary"
          >
            Quitar producto
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Layouts>
      <Title level={4}>Crear prestamo rutas</Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          name="vendedor"
          label="Vendedor"
          rules={[{ required: true }]}
        >
          <Select
            placeholder="Selecciona un Vendedor"
            showSearch={true}
            filterOption={false}
            onSearch={handleSearch}
            onChange={selecionado}
            searchValue={vendorSearch}
            style={{ width: '300px' }} // Increased width for better visibility
          >
            {vendedoresloan.map(vendedor => (
              <Option key={vendedor.id} value={vendedor.id}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <span>
                    {vendedor.first_name} {vendedor.last_name}
                  </span>
                  {vendedor.tope_de_prestamo > 0 && (
                    <span style={{ color: '#52c41a' }}>
                      Tope:{' '}
                      {formatPrice(vendedor.tope_de_prestamo, signoMoneda)}
                    </span>
                  )}
                </div>
              </Option>
            ))}
          </Select>
        </Form.Item>
        {vendedorselect.id ? (
          <>
            {' '}
            <Space size={'large'}>
              Maximo de prestamo:{' '}
              {formatPrice(vendedorselect.tope_de_prestamo, signoMoneda)}
              <span style={{ color: 'red' }}>
                {'      '}
                Prestamo usado:{' '}
                {formatPrice(vendedorselect.prestamo_usado, signoMoneda)}
              </span>
              <span style={{ color: 'green' }}>
                Disponible:{' '}
                {formatPrice(
                  vendedorselect.tope_de_prestamo -
                    vendedorselect.prestamo_usado,
                  signoMoneda
                )}{' '}
              </span>
            </Space>
          </>
        ) : null}
        <Table columns={columns} dataSource={productosagregadosver}></Table>
        Total a prestar : {formatPrice(total, signoMoneda)}
        <span style={{ color: 'red' }}>
          {parseFloat(total) >
          parseFloat(
            vendedorselect.tope_de_prestamo - vendedorselect.prestamo_usado
          )
            ? 'Se excedió el limite de prestamo para el vendedor seleccionado'
            : console.error(
                parseFloat(
                  vendedorselect.tope_de_prestamo -
                    vendedorselect.prestamo_usado
                )
              )}
        </span>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button
            disabled={
              parseFloat(total) >
              parseFloat(
                vendedorselect.tope_de_prestamo - vendedorselect.prestamo_usado
              )
                ? true
                : false
            }
            type="primary"
            htmlType="submit"
            loading={loadings}
          >
            Crear prestamo
          </Button>
        </Form.Item>
      </Form>

      <h4>Añadir productos al prestamo</h4>
      <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }}>
        <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
        <Upload
          accept=".txt"
          beforeUpload={file => {
            processFile(file);
            return false;
          }}
          fileList={fileList}
          onChange={({ fileList }) => setFileList(fileList)}
        >
          <Button icon={<UploadOutlined />} loading={loading} type="primary">
            Cargar archivo de seriales
          </Button>
        </Upload>
      </Space>
      <Modal
        title="Seriales"
        onOk={() => {
          setSerialeslist([]);
          setModalseriales(false);
          deletecambio = false;
        }}
        onCancel={() => {
          setModalseriales(false);
          deletecambio = false;
        }}
        open={modalseriales}
      >
        {serialeslist.map(serial => {
          return (
            <Space size={'small'}>
              {' '}
              <span>{serial.serial}</span>
              <Button
                onClick={() => {
                  Modal.confirm({
                    title: 'Quieres eliminar serial ' + serial.serial,
                    onOk() {
                      let nuevosseriales = productosagregados.filter(
                        item => item.serial !== serial.serial
                      );

                      let arran = arraytotalproductos.filter(
                        item => item.serial !== serial.serial
                      );

                      arraytotalproductos.splice(0, arraytotalproductos.length);

                      arran.map(a => {
                        arraytotalproductos.push(a);
                      });

                      let lisserrialnew = serialeslist.filter(
                        item => item.serial !== serial.serial
                      );

                      setSerialeslist(lisserrialnew);

                      setProductosagregados(nuevosseriales);
                      deletecambio = true;
                    },
                    onCancel() {
                      console.info('cancelar');
                    },
                  });
                }}
              >
                Eliminar
              </Button>
            </Space>
          );
        })}
      </Modal>
    </Layouts>
  );
}

export default LoanCreate;
